import { Button, Image } from '@heroui/react';
import { FC, ReactNode } from 'react';
import { IMenuItems, EMenuItems } from './rightSidebarTypes';

const MenuItemButton: FC<{ item: IMenuItems; onSideButtonClick: (key: string) => void; isMsi: boolean }> = ({ item, onSideButtonClick, isMsi }) => {
	const className = getItemClassName(item);

	return (
		<div title={item.toolTip} className="w-full h-full">
			<Button
				onPress={() => !item.disabled && onSideButtonClick(item.name)}
				aria-readonly
				className={className}
				isDisabled={item.disabled}
				title={item.toolTip} // Add tooltip prop here
			>
				<Image className="h-10 rounded-none mb-0.5" alt={item.name || 'Menu Item'} src={item.logo || ''} />
				<MenuItemLabel item={item} isMsi={isMsi} />
			</Button>
		</div>
	);
};

const MenuItemLabel: FC<{ item: IMenuItems; isMsi: boolean }> = ({ item, isMsi }) => {
	const fontSize = getFontSize(item.value);
	const textColor = getItemTextColor(item);
	const coverageTextColor = item.isActive ? 'text-msi-white-color' : 'text-msi-darkgrey-color-900';

	return (
		<div className="flex flex-col items-end self-end mb-0.5">
			{!item.disabled && item.value && (
				<div className={`font-extrabold text-lg ${textColor}`} style={{ fontSize }}>
					{item.value}
				</div>
			)}
			{isMsi && !item.disabled && item.coverage && (
				<div className={`text-xs font-normal leading-none ${coverageTextColor}`}>
					{`Coverage : ${item.coverage}%`}
				</div>
			)}
		</div>
	);
};

const getItemClassName = (item: IMenuItems) => {
	const baseClass = 'rounded-none flex justify-between bg-msi-white-color w-full h-full border-b-2 px-1 py-0.5';
	if (item.disabled) {
		return `${baseClass} cursor-default`;
	}
	if (item.isActive) {
		return `${baseClass} bg-${item.activeColor}`;
	}
	return baseClass;
};

// const getItemStyle = (item: IMenuItems) => {
//   return {};
// };

const getFontSize = (value: ReactNode) => {
	if (typeof value === 'string' && value.length > 9) {
		return '1.1rem';
	}
	if (typeof value === 'string' && value.length > 8) {
		return '1.2rem';
	}
	if (typeof value === 'string' && value.length > 7) {
		return '1.3rem';
	}
	return '1.5rem';
};

const getItemTextColor = (item: IMenuItems) => {
	if (item.disabled) {
		return 'text-msi-darkgrey-color-800';
	}
	if (item.isActive) {
		return 'text-msi-white-color';
	}
	switch (item.name) {
		case EMenuItems.GREEN:
			return 'text-msi-chart-midgreen';
		case EMenuItems.VALUE:
			return 'text-msi-midblue-color-500';
		case EMenuItems.DCF:
			return 'text-msi-chart-orange';
		default:
			return 'text-msi-darkgrey-color';
	}
};

export { MenuItemButton, MenuItemLabel };
